var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateBillingAsShippingConfirmationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 389,
    viewBox: "0 0 500 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 347.222C0 370.226 18.6632 388.889 41.6667 388.889H458.333C481.337 388.889 500 370.226 500 347.222V194.444H0V347.222ZM166.667 288.194C166.667 282.465 171.354 277.778 177.083 277.778H295.139C300.868 277.778 305.556 282.465 305.556 288.194V322.917C305.556 328.646 300.868 333.333 295.139 333.333H177.083C171.354 333.333 166.667 328.646 166.667 322.917V288.194ZM55.5556 288.194C55.5556 282.465 60.2431 277.778 65.9722 277.778H128.472C134.201 277.778 138.889 282.465 138.889 288.194V322.917C138.889 328.646 134.201 333.333 128.472 333.333H65.9722C60.2431 333.333 55.5556 328.646 55.5556 322.917V288.194ZM500 41.6667V83.3333H0V41.6667C0 18.6632 18.6632 0 41.6667 0H458.333C481.337 0 500 18.6632 500 41.6667Z",
    fill: "#008393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateBillingAsShippingConfirmationIcon);
export default __webpack_public_path__ + "static/media/update-billing-as-shipping-confirmation-icon.eb272272f953a3256bf817b529a394df.svg";
export { ForwardRef as ReactComponent };